<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-row class="flex-nowrap">
      <div class="barLateral">
        <v-nav-draw-anam :anamIndex="anamIndex" :anamGroupShow="anamGroupShow" />
      </div>
      <div class="contentCentral">
        <v-card-form-anam :anamRoute="schema.anamRoute" :observerHCP="observerHCP" />
        <v-card class="d-flex contentCardCentral secundary5 mx-2 justify-center" flat>
          <div style="position: relative">
            <v-slides-correctors
              :headersTable="schema.headersTable"
              :coList="schema.coPackage"
              :coBtnIcons="schema.coBtnIcons"
              :slideDialogItem="schema.slideDialogItem"
              :dialog="dialog"
              :clickTo="clickTo"
              :handleEvents="handleEvents"
              :uploadFileLLaveCo="uploadFileLLaveCo"
              :confirmUploadFileLLaveCo="confirmUploadFileLLaveCo"
              :nameLLaveCo="nameLLaveCo"
              :deleteLlaveCo="deleteLlaveCo"
              :observerHCP="observerHCP"
            />
            <v-sheet
              v-if="observerHCP === true"
              color="transparent"
              style="position: absolute; top: 0; left: 0; width: 100%; height: 93%; z-index: 10"
              class="rounded-lg"
              @mousedown.stop.prevent
              @click.stop.prevent
            >
            </v-sheet>
          </div>
        </v-card>
      </div>
    </v-row>
    <v-overlay
      :value="overlay"
      @update:value="overlay = $event"
      class="d-flex align-star justify-center"
      style="z-index: 1000; position: absolute"
    >
      <v-row class="d-flex justify-center my-5">
        <v-card min-height="200" width="70%" class="secundary6">
          <v-card-title class="text-body-1 font-weight-bold justify-center">
            Aviso
          </v-card-title>
          <v-card-text class="text-body-2">
            {{ overlayMessage }}
          </v-card-text>
          <v-card-actions class="mx-auto mb-5">
            <v-btn
              color="primary"
              class="d-flex mx-auto justify-center"
              @click="toggleOverlay()"
            >
              IR A INDEX
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-overlay>
    <v-snack-bar :snackbar="snackbar" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VNavDrawAnam from '@/components/base/VNavDrawAnam.vue';
import VCardFormAnam from '@/components/base/VCardFormAnam.vue';
import VSlidesCorrectors from '@/components/base/VSlidesCorrectors.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'CorrectorsPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VNavDrawAnam,
    VCardFormAnam,
    VSlidesCorrectors,
    VSnackBar,
  },
  data() {
    return {
      overlay: false,
      overlayMessage: '',
      dialog: false,
      fileLLaveCo: null,
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    ...mapGetters('testCorrectors', ['schema', 'nameLLaveCo']),
    ...mapGetters('anamPermissions', ['anamIndex', 'anamGroupShow', 'hasPermission', 'observerHCP']),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('testCorrectors', [
      'loadSchema',
      'loadFileLLaveCo',
      'submitFileLLaveCo',
      'deleteLlaveCo',
    ]),
    ...mapActions('anamPermissions', ['loadPermissionsHCP', 'sectionsHCPandRoute', 'checkPermission', 'loadObserverHCP']),
    ...mapActions('notifications', ['triggerSnackbar']),

    handleEvents() {},

    async loadData() {
      try {
        await Promise.all([
          this.loadSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (this.hasPermission) {
          await this.loadFileLLaveCo();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },

    clickTo(clickItem) {
      this.$store.commit('auth/setCoNew', true);
      if (this.nameLLaveCo === undefined) {
        this.snackbar.visible = false;
        this.snackbar.visible = true;
        this.snackbar.content = 'Primero debe adjuntar la llave de los correctores.';
        this.dialog = false;
        this.dialog = true;
      } else {
        if (clickItem.coPlat !== '') {
          this.$router.push({ name: `co-${clickItem.coPlat.substring(5, 7)}` });
          this.$route.query;
        }
      }
    },

    uploadFileLLaveCo(e) {
      const file = e.target.files[0];
      this.fileLLaveCo = file;
    },

    async confirmUploadFileLLaveCo() {
      if (this.fileLLaveCo) {
        try {
          await this.submitFileLLaveCo(this.fileLLaveCo);
          this.dialog = false;
        } catch {
          alert('Error al subir el archivo.');
        }
      } else {
        alert('Faltó seleccionar el archivo correspondiente.');
      }
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },
  },
};
</script>

<style>
.barLateral {
  min-width: 60px;
}

.contentCentral {
  width: 96%;
}

.contentCardCentral {
  width: 98.5%;
  margin-top: 90px;
}

.contentRowCentral {
  width: 80%;
  min-height: 400px;
}

.bannerAction {
  width: 87%;
  height: 48px;
}
</style>
